import CustomPalette from '@/theme/CustomPalette'
import CloseIcon from '@mui/icons-material/Close'
import { Box, IconButton, Typography } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export const MobileWarningBanner = (): JSX.Element | null => {
  const { t } = useTranslation('general')
  const [isDismissed, setIsDismissed] = useState(false)

  if (isDismissed) {
    return null
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: CustomPalette.SecondaryNightBlue50,
        padding: '16px',
        gap: '12px',
        marginLeft: { xs: 0, sm: -2 },
        marginRight: { xs: 0, sm: -2 },
        width: { xs: '100%', sm: 'calc(100% + 32px)' },
        marginBottom: '32px',
      }}>
      <Typography
        sx={{
          fontSize: '16px',
          color: CustomPalette.SecondaryNightBlue900,
          textAlign: 'left',
          flex: 1,
        }}>
        {t('mobile_warning_banner.message')}
      </Typography>
      <IconButton
        aria-label={t('close')}
        onClick={() => setIsDismissed(true)}
        sx={{
          width: '40px',
          height: '40px',
          padding: 0,
          border: 'none',
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: 'transparent',
          },
        }}>
        <CloseIcon sx={{ color: CustomPalette.SecondaryNightBlue900 }} />
      </IconButton>
    </Box>
  )
}
